import { render, staticRenderFns } from "./weighing-record.vue?vue&type=template&id=1912e36e&"
import script from "./weighing-record.vue?vue&type=script&lang=js&"
export * from "./weighing-record.vue?vue&type=script&lang=js&"
import style0 from "./weighing-record.vue?vue&type=style&index=0&id=1912e36e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports